// as the component is used directly from markdown library it has all its attributes as strings
import { useTranslations } from 'next-intl';
import dayjs from 'dayjs';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

// All the inputs are strings as we receive them from the markdown library,
// so we need to convert them to the correct types in the component itself
interface AITaskProps {
  url: string;
  done: string;
  title: string;
  id: string;
  description: string;
  assigneeUserIds: string;
  deadlineDate: string;
  createdAt: string;
  labels: string;
  boardTitle?: string;
  taskListTitle: string;
  onClick: () => void;
}

export function AITask({
  title,
  done: sDone,
  deadlineDate: sDeadlineDate,
  boardTitle,
  taskListTitle,
  onClick,
}: AITaskProps) {
  const t = useTranslations('features');

  const done = sDone === 'true';
  let deadlineDate: string | null = null;
  if (sDeadlineDate && sDeadlineDate !== 'null') {
    deadlineDate = dayjs(sDeadlineDate).format('D MMM');
  }

  return (
    <div className="bg-white pl-3 pr-4 py-3 hover:bg-neutral-100 rounded-md cursor-pointer ai-task" onClick={onClick}>
      <div className="flex flex-row items-start text-neutral-700 text-sm font-medium leading-tight">
        {done ? (
          <Icon icon={IconsMap.CHECK_CIRCLE_FILL} className="w-[16px] h-[16px] mr-2 text-neutral-400" />
        ) : (
          <Icon icon={IconsMap.CIRCLE_DASHED} className="w-[16px] h-[16px] mr-2" />
        )}

        {title}
      </div>
      {boardTitle ? (
        <div className="text-neutral-500 pl-6 flex flex-row items-start mt-2">
          <Icon icon={IconsMap.BOARD} className="w-[16px] h-[16px] mr-1 mt-1" />
          <span>
            {t('ai-helper.kanban_board')}: {boardTitle} {taskListTitle ? `• ${taskListTitle}` : ''}
          </span>
        </div>
      ) : null}
      {taskListTitle && !boardTitle ? (
        <div className="text-neutral-500 pl-6 flex flex-row mt-2 items-start">
          <Icon icon={IconsMap.TASKS} className="w-[16px] h-[16px] mt-1 mr-1" />
          <span>
            {t('ai-helper.task_list')}: {taskListTitle}
          </span>
        </div>
      ) : null}
      {deadlineDate ? (
        <div className="text-neutral-500 pl-6 flex flex-row items-center mt-[6px]">
          <Icon icon={IconsMap.CALENDAR} className="w-[16px] h-[16px] mr-1" />
          <span>
            {t('ai-helper.deadline')}: {deadlineDate}
          </span>
        </div>
      ) : null}
    </div>
  );
}
